import { invert } from 'lodash';

const eventTypes = {
  workout: 1,
  task: 2,
  trainerTask: 3,
};

const stringForEventType = invert(eventTypes);

const MapEventTypeToUpdateEndpoint = {
  workout: 'Workout/UpdateWorkoutLog',
  task: 'Trainer/UpdateClientTask',
  trainerTask: 'Trainer/UpdateTrainerTask',
};

const MapEventTypeToUpdateEndpointPlural = {
  workout: 'Workout/UpdateWorkoutLogs',
  task: 'Trainer/UpdateClientTasks',
  trainerTask: 'Trainer/UpdateTrainerTasks',
};

const MapEventTypeToUpdateClientEndpoint = {
  workout: 'Client/UpdateWorkoutLog',
  task: 'Client/UpdateClientTask',
};

const MapEventTypeToCompleteEndpoint = {
  workout: 'Client/UpdateWorkoutLogCompletion',
  task: 'Client/UpdateTaskCompletion',
};

const MapEventTypeToUpdateEndpointForMove = {
  workout: 'Trainer/UpdateWorkoutLogDate',
  task: 'Trainer/UpdateClientTask',
  trainerTask: 'Trainer/UpdateTrainerTask',
};

const MapEventTypeToCopyEndpoint = {
  workout: 'Trainer/CopyWorkoutLogDate',
  task: 'Trainer/CreateClientTask',
  trainerTask: 'Trainer/CreateTrainerTask',
};

const MapEventTypeToDate = {
  workout: 'date',
  task: 'dueDate',
  trainerTask: 'dueDate',
};

// WORK IN PROGRESS - NOT IN USE ANYWHERE AS OF 2018-11-09
const mapEventTypeToRoute = new Map([
  [
    eventTypes.workout,
    {
      client: {
        create: 'FoodLogEntryScreen',
        update: 'Workout/UpdateWorkoutLog',
        delete: 'Workout/',
      },
      trainer: {
        // Put trainer workout creation or update endpoints here??
      },
    },
  ],
  [eventTypes.task, { client: 'BodyStatScreen', label: 'Record Body Stat' }],
  [
    eventTypes.trainerTask,
    { route: 'ProgressPhotosScreen', label: 'Take Progress Photo' },
  ],
]);

export {
  eventTypes,
  stringForEventType,
  MapEventTypeToUpdateEndpoint,
  MapEventTypeToUpdateEndpointPlural,
  MapEventTypeToUpdateEndpointForMove,
  mapEventTypeToRoute,
  MapEventTypeToCopyEndpoint,
  MapEventTypeToUpdateClientEndpoint,
  MapEventTypeToCompleteEndpoint,
  MapEventTypeToDate,
};
